export default __webpack_public_path__ + "static/media/three_dots.4c2b04bb.svg";